import {makeStyles} from '@material-ui/core';
import {getDirectionStyles} from '../../../../../utils/ThemeUtils';

const useStyles = makeStyles(theme => ({
    activationsWrapper: {
        paddingTop: theme.spacing(2),
        gridArea: 'game-xp-footer',
        marginBottom: theme.spacing(5),

        [theme.breakpoints.up('fsm')]: {
            marginBottom: 0,
            paddingTop: theme.spacing(8)
        },

        [theme.breakpoints.up('lg')]: {
            position: 'relative'
        }
    },
    headersWrapper: {
        display: 'flex',
        color: theme.palette.text.secondary,
        marginBottom: theme.spacing(2),

        [theme.breakpoints.up('fsm')]: {
            marginBottom: theme.spacing(3)
        },

        [theme.breakpoints.up('fmd')]: {
            marginBottom: theme.spacing(5)
        }
    },
    headerName: {
        width: 'calc(100% - 132px)',
        minWidth: 'calc(100% - 132px)',
        padding: getDirectionStyles(theme.direction)(
            theme.spacing(0, 0, 0, 5),
            theme.spacing(0, 5, 0, 0)
        ),
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(20),

        [theme.breakpoints.up('fsm')]: {
            width: 300,
            minWidth: 300,
            padding: getDirectionStyles(theme.direction)(
                theme.spacing(0, 10, 0, 5),
                theme.spacing(0, 5, 0, 10)
            ),
            fontSize: theme.typography.pxToRem(18),
            lineHeight: theme.typography.pxToRem(25)
        }
    },
    headerActivationNumber: {
        fontSize: theme.typography.pxToRem(14),
        lineHeight: theme.typography.pxToRem(20),

        [theme.breakpoints.up('fsm')]: {
            fontSize: theme.typography.pxToRem(18),
            lineHeight: theme.typography.pxToRem(25)
        }
    }
}));

export default useStyles;
